/**
 * Ryan O'Dowd
 * 2023-01-01
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts}) => {
  return {
    bold: {
      fontFamily: fonts.primaryBold,
    },
  };
};

export default getStyles;
